import http from 'hub-http/clients/apiClient';
import { User } from '../types/User';

const BASE_URL = 'permissions-skynet/v1';

export default {
  fetchUsersByScope: (scope: string): Promise<User[]> =>
    http.get(`${BASE_URL}/scopes/app/${scope}/hub-users`),
};
